import React from 'react'

import { DepthKeys, useLanguages } from '@/hooks'
import { IPageData } from '@/types'

import { FAQList } from '../../faq/components'

export const FAQ: React.FC<
  IPageData['data']['template'] & { title?: DepthKeys; className?: string }
> = ({ title, className, ...template }) => {
  const { t } = useLanguages()

  if (!template?.faq?.length) return null

  return (
    <FAQList
      items={template.faq}
      className={className}
      title={t(title ?? 'oneWayCarRentalFAQ')}
    />
  )
}
